function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUpDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.179,9.967L2.679,9.967C1.713,9.967 0.929,10.751 0.929,11.668L0.929,23.869C0.929,24.835 1.713,25.57 2.679,25.57L6.179,25.57C7.145,25.57 7.929,24.786 7.929,23.869L7.929,11.717C7.929,10.799 7.147,9.967 6.179,9.967ZM28.929,11.931C28.929,9.913 27.286,8.271 25.266,8.271L19.805,8.271C20.327,6.905 20.616,5.724 20.616,5.029C20.616,3.181 19.184,1.268 16.785,1.268C14.236,1.268 13.539,3.042 12.978,4.467C11.247,8.869 9.679,8.098 9.679,9.579C9.679,10.281 10.245,10.891 10.992,10.891C11.28,10.891 11.569,10.796 11.811,10.603C16.009,7.247 14.981,3.893 16.785,3.893C17.664,3.893 17.991,4.59 17.991,5.03C17.991,5.435 17.576,7.193 16.594,8.945C16.482,9.144 16.426,9.365 16.426,9.586C16.426,10.347 17.052,10.849 17.739,10.849L25.264,10.849C25.839,10.897 26.304,11.362 26.304,11.931C26.304,12.467 25.879,12.917 25.338,12.954C24.645,13.001 24.115,13.577 24.115,14.263C24.115,15.109 24.738,15.135 24.738,15.844C24.738,17.232 22.822,16.519 22.822,18.149C22.822,18.763 23.171,18.862 23.171,19.366C23.171,20.605 21.543,20.119 21.543,21.589C21.543,21.835 21.604,21.915 21.604,22.106C21.604,22.677 21.138,23.142 20.567,23.142L17.694,23.142C16.293,23.142 14.904,22.679 13.784,21.84L11.779,20.335C11.543,20.158 11.267,20.072 10.993,20.072C10.235,20.072 9.678,20.695 9.678,21.387C9.678,21.786 9.86,22.176 10.203,22.433L12.209,23.938C13.78,25.116 15.727,25.767 17.696,25.767L20.569,25.767C22.501,25.767 24.088,24.263 24.222,22.365C25.194,21.696 25.799,20.587 25.799,19.367C25.799,19.2 25.787,19.033 25.764,18.868C26.739,18.203 27.365,17.086 27.365,15.845C27.365,15.554 27.33,15.268 27.262,14.989C28.267,14.288 28.929,13.199 28.929,11.931Z",
    style: {
      fill: "#c0bab7",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUpDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbs-up-default.f475356ee8eea57ccb8dce6dc52ad6f5.svg";